<div class="container-fluid imagen-fondo" fxLayout="column" fxLayoutAlign="space-between stretch"
    style="height: 90vh !important;">
    <div fxLayout="row" fxLayoutAlign="center" class="mt-12 ml-5 md:ml-0 border-gray-100 border-b-2">
        <p class="text-4xl font-sans font-bold text-black dark:text-white">¡Bienvenido, {{usuario}}!</p>
    </div>
    <div fxLayout="row">

    </div>
</div>